import React from 'react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

import {Button} from '@homeaway/react-buttons';

import {withTranslationsAsProps} from '../../../translations';

function HitDelisted(props) {
    const {
        delistedMessage,
        delistedRemove,
        delistedTitle,
        onDelete,
        siteDisplayName,
        listingId
    } = props;

    function handleRemoveClick(event) {
        event.preventDefault();
        onDelete(event, listingId);
        event.stopPropagation();
    }
    
    return (
        <div className="scratchpad-hit-delisted">
            <div className="scratchpad-hit-delisted__title">
                <FormattedMessage
                    id="greeting.welcome_message"
                    defaultMessage={delistedTitle}
                    values={{Brand: siteDisplayName}}
                />
            </div>
            <div className="scratchpad-hit-delisted__message">
                {delistedMessage}
            </div>
            <Button
                className="scratchpad-hit-delisted__remove-button"
                label={delistedRemove}
                onClick={handleRemoveClick}
                size="sm"
            />
        </div>
    );
}

HitDelisted.propTypes = {
    delistedMessage: PropTypes.string,
    delistedRemove: PropTypes.string,
    delistedTitle: PropTypes.string,
    onDelete: PropTypes.func,
    siteDisplayName: PropTypes.string,
    listingId: PropTypes.string,
};

export default withTranslationsAsProps({
    'tripboards.error.delisted.message': 'delistedMessage',
    'tripboards.error.delisted.remove': 'delistedRemove',
    'tripboards.error.delisted.title': 'delistedTitle',
})(HitDelisted);



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitDelisted/HitDelisted.js